import {
	ChangeDetectionStrategy,
	Component,
	forwardRef,
	HostBinding,
	Input,
	SkipSelf,
	ViewEncapsulation,
} from '@angular/core';
import { CommonControlComponent } from '../control/control.class';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
	selector: 'common-boolean-checkbox',
	templateUrl: './boolean_checkbox.component.pug',
	changeDetection: ChangeDetectionStrategy.OnPush,
	styleUrls: ['./boolean_checkbox.component.sass'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => CommonBooleanCheckboxComponent),
			multi: true,
		},
	],
	viewProviders: [
		{
			provide: ControlContainer,
			useFactory: (container: ControlContainer) => container,
			deps: [[new SkipSelf(), ControlContainer]],
		},
	],
	encapsulation: ViewEncapsulation.None,
})
export class CommonBooleanCheckboxComponent extends CommonControlComponent<boolean> {
	@Input() label: string; // Labels text (text)
	@Input() htmlLabel: string; // Labels text (HTML)
	@Input() labelClasses: string; // CSS classes for label
	@Input() checkboxId: string; // Id for linkng with label
	@Input() indeterminate: boolean; // Indeterminate view mode
	@Input() ctrlCheckboxClasses: string;
	@Input() required: boolean = false;

	@HostBinding('attr.tabindex') @Input() get formTabIndex(): number {
		return null;
	}

	protected idKey = 'boolean_checkbox_';

	onChangeCheckbox(value: boolean) {
		const oldValue = this.model;
		this.model = value;

		if (oldValue !== value) {
			this.modelChange.emit(value);
			this.emitOnChange(value);
		}
	}

	writeValue(value): void {
		const normalizeValue = !!value; // to boolean

		super.writeValue(normalizeValue);

		if (normalizeValue !== value) {
			// Wait register change subscribers in the CommonCustomReactiveFormService#updateReactiveForm
			setTimeout(() => {
				(this.ngModelControl || this.formControlDirective).control.setValue(this.model, { emitModelToViewChange: false });
			});
		}
	}
}
